import type { Banner as BannerEntry } from '../../../schema/spaces/ecommerce-petsmart';
import { optimizeImage, propsImagesItems } from '../../../utils/propsImagesItems';
import type { BannerProps } from './types';

const BANNER_SIZE = {
    Small: 'sm',
    Medium: 'md',
    Category: 'md-alt',
    Large: 'lg',
    'Landing Page': 'xlg',
} as const;

export function transformBanner(
    entry: BannerEntry,
    { headingTagName = 'h2' }: Partial<Pick<BannerProps, 'headingTagName'>> = {}
): BannerProps {
    const { variant, header, description, textColor, textAlignment, image, cta } = entry.fields;
    const sources = propsImagesItems(optimizeImage(image.fields), true);

    return {
        size: BANNER_SIZE[variant],
        title: header,
        description,
        headingTagName,
        inverted: textColor === 'White',
        align: textAlignment === 'Center' ? 'center' : 'left',
        image: { src: sources[0]?.srcSet ?? '', alt: image.fields.webAltText, sources },
        cta: cta
            ? {
                  label: cta.fields.text,
                  href: cta.fields.link.fields.webUrl || undefined,
                  target: cta.fields.behavior === 'New Tab' ? '_blank' : '_self',
                  variant: cta.fields.buttonStyle === 'Primary' ? 'primary' : 'table-header',
              }
            : undefined,
    };
}
